export default "__VITE_ASSET__81e9fe88__"